// extracted by mini-css-extract-plugin
export default {"heading":"Ik-z","list":"Jk-z"};